import React from 'react';

import { FolderModel } from '../../../../../../typings/api/skymap/rest/v1/.common';
import { Icon } from '../../icon/icon';

type Props = {
  className?: string;
  folder: FolderModel;
  opened: boolean;
};

const FolderIcon = (props: Props) => {
  const totalNumFiles = props.folder.numFiles + props.folder.numFilesSubFolders;
  const isEmpty = totalNumFiles === 0;

  return totalNumFiles > 0 ? (
    <Icon
      className={props.className}
      data-testid={isEmpty ? 'icon-folder-empty' : 'icon-folder-not-empty'}
      fixedWidth={true}
      icon={['fad', props.opened ? 'folder-open' : 'folder']}
      style={{
        ['--fa-secondary-color' as any]: '#5f686d',
        ['--fa-secondary-opacity' as any]: 0.7,
      }}
    />
  ) : (
    <Icon
      className={props.className}
      data-testid={isEmpty ? 'icon-folder-empty' : 'icon-folder-not-empty'}
      fixedWidth={true}
      icon={['fad', props.opened ? 'folder-open' : 'folder']}
      style={{
        ['--fa-secondary-color' as any]: '#d1d4d3',
        ['--fa-secondary-opacity' as any]: 0.7,
      }}
    />
  );
};

export { FolderIcon };
